export class UserUpdateRequest {
  constructor(public id: string, public name: string) {}
}
